import React from 'react';
import PropTypes from 'prop-types';
import { FILE_TYPE } from 'Consts/File';
import FolderItem from './FolderItem';

const Breadcrumb = ({ items, handleNavigation }) => {
  const breadcrumbItems = items.map(item => (
    <FolderItem
      key={item.id}
      relatedFileIds={items.map(i => i.type === FILE_TYPE && i.id)}
      item={item}
      handleNavigation={handleNavigation}
      breadcrumb
    />
  ));
  return <div id="breadcrumb">{breadcrumbItems}</div>;
};

Breadcrumb.propTypes = {
  items: PropTypes.array.isRequired,
  handleNavigation: PropTypes.func.isRequired,
};

export default Breadcrumb;
